import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {InventoryService} from './inventory.service';
import {FileDownloadService} from './file-download.service';
import {IMyDateModel} from 'mydatepicker';
import {AppComponent} from './app.component';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

@Component({
    selector: 'inventories-list',
    templateUrl: './templates/inventories-list.component.html',
    styleUrls: ['./styles/inventories-list.component.css'],
    providers: [InventoryService, FileDownloadService, SortTable],
    encapsulation: ViewEncapsulation.None
})
export class InventoriesListComponent implements OnInit {

    liste_rapports: Array<any> = [];
    details_rapports: Array<any> = [];
    reference: any = '';
    date: any = '';

    rapport_selected: any;
    sortedData: any = [];

    constructor(
        private app_component: AppComponent,
        private inventory_service: InventoryService,
        private file_download_service: FileDownloadService,
        private sort_table: SortTable
    ) {
        this.app_component.valTest = '/inventory-reports';
        this.app_component.GetParent();
    }

    ngOnInit() {
        this.getRapports();
    }

    viewDetails(rapport: any) {
        this.rapport_selected = rapport;
        this.inventory_service.viewDetails(rapport.id_stocktaking)
            .then(result => {
                this.details_rapports = result['list_right'];
            });
    }

    onDateChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date = "";
        } else {
            this.date = event.jsdate.toLocaleDateString("en-US");
        }
        this.getRapports();
    }

    getRapports(): void {
        this.inventory_service.getRapports(this.reference, this.date)
            .then(result => {
                this.liste_rapports = result['list'];
                this.sortedData = result['list'];
                this.sort_table.SetDataArray(result['list'], [{value: "reference", type: ""}, {value: "date", type: ""}]);
            });
    }


    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }

    generatePdf(): void {
        // this.file_download_service.downloadFile(this.rapport_selected.id_stocktaking);
        this.file_download_service.downloadFile(this.rapport_selected);
    }

    //    other
    Clean(str: string): string {
        var space = String.fromCharCode(160);
        var res_1 = String(str).replace('&nbsp;', ' ');
        //var res_2 = String(res_1).replace(/space/g, ' ');
        var res_2 = String(res_1).replace(new RegExp(space, 'gi'), ' ');
        return res_2;
    }

    CleanFormatPrice(str_price: string): number {
        var str_price = this.Clean(str_price);
        var no_space = str_price.split(' ');
        return parseInt(no_space.join(''));
    }

    formatNumber(price: string): string {
        if (price !== "") {
            let clean_price = this.CleanFormatPrice(price);
            if (!isNaN(Number(clean_price))) {
                return Math.round(clean_price).toLocaleString();
            } else {
                return "0";
            }
        } else {
            return "0";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/inventories-list.component.ts